import React from 'react';
import { Box, Stack, Text } from '@mantine/core';
import { PopupEventVendorDetailsUpcoming } from '../types';
import MealHistoricalItem from './MealHistoricalItem';

type PopupUpcomingHistoryProps = {
  event: PopupEventVendorDetailsUpcoming;
};

const PopupUpcomingHistory: React.FC<PopupUpcomingHistoryProps> = ({ event }) => {
  const historical = event.historical || [];
  const historicalMax = Math.max(...historical.map((h) => h.sales?.mealsSold ?? 0));

  return (
    <Stack gap="4">
      <Text>Your Historical Meals Sold at this location</Text>
      <Box p="sm" bdrs="md" bd="1px solid var(--mantine-color-gray-4)">
        {historical?.length ? (
          event.historical?.map((historical) => (
            <MealHistoricalItem
              historical={historical}
              key={historical.id}
              maxSold={historicalMax}
            />
          ))
        ) : (
          <Text fz="sm" fw="bold" ta="center">
            This will be your first time visiting this location
          </Text>
        )}
      </Box>
    </Stack>
  );
};

export default PopupUpcomingHistory;
